/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UploadImageRequest,
} from '../models';
import {
    UploadImageRequestFromJSON,
    UploadImageRequestToJSON,
} from '../models';

export interface CreateExternalImageRequest {
    uri: string;
}

export interface CreateExternalImage1Request {
    uri: string;
}

export interface GetImageRequest {
    imageId: string;
}

export interface GetImage1Request {
    imageId: string;
}

export interface GetImageLegacyRequest {
    id: string;
}

export interface GetImageLegacy1Request {
    id: string;
}

export interface UploadImageOperationRequest {
    uploadImageRequest?: UploadImageRequest;
}

export interface UploadImage1Request {
    uploadImageRequest?: UploadImageRequest;
}

/**
 * 
 */
export class ImageControllerApi extends runtime.BaseAPI {

    /**
     */
    async createExternalImageRaw(requestParameters: CreateExternalImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.uri === null || requestParameters.uri === undefined) {
            throw new runtime.RequiredError('uri','Required parameter requestParameters.uri was null or undefined when calling createExternalImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.uri !== undefined) {
            queryParameters['uri'] = requestParameters.uri;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image/create-external`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async createExternalImage(uri: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createExternalImageRaw({ uri: uri }, initOverrides);
        return await response.value();
    }

    /**
     */
    async createExternalImage1Raw(requestParameters: CreateExternalImage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.uri === null || requestParameters.uri === undefined) {
            throw new runtime.RequiredError('uri','Required parameter requestParameters.uri was null or undefined when calling createExternalImage1.');
        }

        const queryParameters: any = {};

        if (requestParameters.uri !== undefined) {
            queryParameters['uri'] = requestParameters.uri;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image.do/create-external`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async createExternalImage1(uri: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createExternalImage1Raw({ uri: uri }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getImageRaw(requestParameters: GetImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling getImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image/{imageId}`.replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getImage(imageId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getImageRaw({ imageId: imageId }, initOverrides);
    }

    /**
     */
    async getImage1Raw(requestParameters: GetImage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling getImage1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image.do/{imageId}`.replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getImage1(imageId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getImage1Raw({ imageId: imageId }, initOverrides);
    }

    /**
     */
    async getImageLegacyRaw(requestParameters: GetImageLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getImageLegacy.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getImageLegacy(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getImageLegacyRaw({ id: id }, initOverrides);
    }

    /**
     */
    async getImageLegacy1Raw(requestParameters: GetImageLegacy1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getImageLegacy1.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/image.do`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getImageLegacy1(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getImageLegacy1Raw({ id: id }, initOverrides);
    }

    /**
     */
    async uploadImageRaw(requestParameters: UploadImageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadImageRequestToJSON(requestParameters.uploadImageRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async uploadImage(uploadImageRequest?: UploadImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadImageRaw({ uploadImageRequest: uploadImageRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadImage1Raw(requestParameters: UploadImage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/image.do`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadImageRequestToJSON(requestParameters.uploadImageRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async uploadImage1(uploadImageRequest?: UploadImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadImage1Raw({ uploadImageRequest: uploadImageRequest }, initOverrides);
        return await response.value();
    }

}
